import { createContext } from 'react';


const ModalContext = createContext();

export default ModalContext;


/*** Scripts end... */
